
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
import { default as glossary8Rd_GJznugRqqmVTXm892jAVugeHc7VkGV6XgX3Z3kEMeta } from "/app/app/pages/glossary.vue?macro=true";
import { default as site_45mapOy6AcfcC76D29vP_iMsEL5qU8RG5HZy6WOQXkOoVO9UMeta } from "/app/app/pages/site-map.vue?macro=true";
import { default as indexiHk2hVhQ85I4HiaKEx3vQDlaKfcsYebgN6TEqT398hoMeta } from "/app/layers/pro/app/pages/pro/index.vue?macro=true";
import { default as indexXk6BRG1q7gGuooYSZur2VGWTIfOP1eKiIeRLuTmPRI4Meta } from "/app/layers/news/app/pages/news/index.vue?macro=true";
import { default as indexrV_LAYE_CYlPgXwbfoWuBXrruO5E9N8UnnJfokiaIloMeta } from "/app/app/pages/tools/index.vue?macro=true";
import { default as about_45unbiasedNRVug6UElBkI1KxUpyBhS4rUuKOXljpr0516k2W3v1oMeta } from "/app/app/pages/about-unbiased.vue?macro=true";
import { default as _91_46_46_46slug_93tgE34ObKOLy74SkUqMVYUCLuLUxTsa_gf_4CKwo2cP8Meta } from "/app/app/pages/legals/[...slug].vue?macro=true";
import { default as _91offer_93g8WcpDKd9e82fTJccPiwYCHofYluq_mwWdoRtMsqAKQMeta } from "/app/layers/campaigns/app/pages/campaigns/[offer].vue?macro=true";
import { default as _91slug_93kbzsLlJhiT8ULHjXrH9xGr8AYuwMCikxqzbL_DLO_mEMeta } from "/app/layers/campaigns/app/pages/campaigns/p/[slug].vue?macro=true";
import { default as the_45unbiased_45storyJJCtdxRKa9HVpgLgPX8Sh680RLpqTks_YIyOIUiIqkYMeta } from "/app/app/pages/the-unbiased-story.vue?macro=true";
import { default as _91authorName_93iLTr1_iwneTwBhPJGl0wlh4gREynpwBfLwoUwgpy494Meta } from "/app/app/pages/authors/[authorName].vue?macro=true";
import { default as cost_45of_45advicei2fseL8xG_yh6TJSxaGi6_MqC8jZF744EowpjkhD_fsMeta } from "/app/app/pages/tools/cost-of-advice.vue?macro=true";
import { default as email_45updates0Je8_apuXRZpGKQ9QmbGYcpZC2Hg0npMhVAU_1XXVNQMeta } from "/app/app/pages/consumer/email-updates.vue?macro=true";
import { default as indexcZNtIWWtkROagL7PcU8iRNMNppJKkHtjJf6Tul_Oq1cMeta } from "/app/layers/news/app/pages/news/[subcategory]/index.vue?macro=true";
import { default as mortgage_45checklistk1fZ26ZXY2BhnKsIUKDm8awC5yRcUjuUDRAW9OkwyMYMeta } from "/app/app/pages/tools/mortgage-checklist.vue?macro=true";
import { default as indexEPd6Zw69tlCSTaq9kHRbNb6hPrkMRKCcanqMkKLGER4Meta } from "/app/app/pages/discover/[category]/index.vue?macro=true";
import { default as mortgage_45calculatorQiyIHqW_wZHbWyNEAUAuAh2Bl43QcHyRjw3UbzHQZt4Meta } from "/app/app/pages/tools/mortgage-calculator.vue?macro=true";
import { default as free_45pension_45guidetAraHSslukRtoJexaCJEjwj8X522QJgXmCXB3VA9zjoMeta } from "/app/layers/campaigns/app/pages/campaigns/free-pension-guide.vue?macro=true";
import { default as _91article_93aKy0ipiHZIei_EpGXAl7NYHC5cgtYdBf1Nmhbnag_NsMeta } from "/app/layers/news/app/pages/news/[subcategory]/[article].vue?macro=true";
import { default as indexZ5ZabneCbyJPxAfaAmZsobIa2d0KZFkdrj_TEZ_UCUQMeta } from "/app/layers/pro/app/pages/pro/discover/[category]/index.vue?macro=true";
import { default as _91article_93OZinFMyaXwssgGjb14g5qMytSCv2PriOrQb2u0XSGzsMeta } from "/app/layers/pro/app/pages/pro/discover/[category]/[article].vue?macro=true";
import { default as wealth_45managerMa0ZConeFcYjT_HcOESREOBtg5RAKYITlRk2ZUicYaAMeta } from "/app/layers/campaigns/app/pages/campaigns/(information)/wealth-manager.vue?macro=true";
import { default as indexihfMcG1VzCdMz8xnoGphdfI_wNd7ZXEgJbbZLMLlDUgMeta } from "/app/app/pages/discover/[category]/[subcategory]/index.vue?macro=true";
import { default as nhs_45pension_45advicesG_xBctwk4zcB7rxPGBe5k6hwcOhH7b7vUCLqtC1TEgMeta } from "/app/layers/campaigns/app/pages/campaigns/(information)/nhs-pension-advice.vue?macro=true";
import { default as _91article_93Ii43Sp_AlwqG1zzFlgci_eipcPi0QzfaffYk4L2ez3EMeta } from "/app/app/pages/discover/[category]/[subcategory]/[article].vue?macro=true";
import { default as online_45financial_45adviserjb_ExypFbbptErmmxNnrFANhaaa_XHvaSbEKU1QdAgUMeta } from "/app/layers/campaigns/app/pages/campaigns/(information)/online-financial-adviser.vue?macro=true";
import { default as how_45to_45get_45a_45mortgage_45free_45mortgage_45guide73w0J_OFGSnUiVn1RgCxjABRMqYnWcFN6IBogcjV0acMeta } from "/app/layers/campaigns/app/pages/campaigns/how-to-get-a-mortgage-free-mortgage-guide.vue?macro=true";
import { default as accountants_45for_45small_45business2L6_dtMYMVvAvDyxVZx6b52zvg1tcVXGMYVAxBzmnE8Meta } from "/app/layers/campaigns/app/pages/campaigns/(information)/accountants-for-small-business.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "glossary",
    path: "/glossary",
    component: () => import("/app/app/pages/glossary.vue")
  },
  {
    name: "site-map",
    path: "/site-map",
    component: () => import("/app/app/pages/site-map.vue")
  },
  {
    name: "pro",
    path: "/pro",
    component: () => import("/app/layers/pro/app/pages/pro/index.vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/app/layers/news/app/pages/news/index.vue")
  },
  {
    name: "tools",
    path: "/tools",
    component: () => import("/app/app/pages/tools/index.vue")
  },
  {
    name: "about-unbiased",
    path: "/about-unbiased",
    component: () => import("/app/app/pages/about-unbiased.vue")
  },
  {
    name: "legals-slug",
    path: "/legals/:slug(.*)*",
    component: () => import("/app/app/pages/legals/[...slug].vue")
  },
  {
    name: "campaigns-offer",
    path: "/campaigns/:offer()",
    meta: _91offer_93g8WcpDKd9e82fTJccPiwYCHofYluq_mwWdoRtMsqAKQMeta || {},
    component: () => import("/app/layers/campaigns/app/pages/campaigns/[offer].vue")
  },
  {
    name: "campaigns-p-slug",
    path: "/campaigns/p/:slug()",
    meta: _91slug_93kbzsLlJhiT8ULHjXrH9xGr8AYuwMCikxqzbL_DLO_mEMeta || {},
    component: () => import("/app/layers/campaigns/app/pages/campaigns/p/[slug].vue")
  },
  {
    name: "the-unbiased-story",
    path: "/the-unbiased-story",
    component: () => import("/app/app/pages/the-unbiased-story.vue")
  },
  {
    name: "authors-authorName",
    path: "/authors/:authorName()",
    component: () => import("/app/app/pages/authors/[authorName].vue")
  },
  {
    name: "tools-cost-of-advice",
    path: "/tools/cost-of-advice",
    component: () => import("/app/app/pages/tools/cost-of-advice.vue")
  },
  {
    name: "consumer-email-updates",
    path: "/consumer/email-updates",
    component: () => import("/app/app/pages/consumer/email-updates.vue")
  },
  {
    name: "news-subcategory",
    path: "/news/:subcategory()",
    component: () => import("/app/layers/news/app/pages/news/[subcategory]/index.vue")
  },
  {
    name: "tools-mortgage-checklist",
    path: "/tools/mortgage-checklist",
    component: () => import("/app/app/pages/tools/mortgage-checklist.vue")
  },
  {
    name: "discover-category",
    path: "/discover/:category()",
    component: () => import("/app/app/pages/discover/[category]/index.vue")
  },
  {
    name: "tools-mortgage-calculator",
    path: "/tools/mortgage-calculator",
    component: () => import("/app/app/pages/tools/mortgage-calculator.vue")
  },
  {
    name: "campaigns-free-pension-guide",
    path: "/campaigns/free-pension-guide",
    component: () => import("/app/layers/campaigns/app/pages/campaigns/free-pension-guide.vue")
  },
  {
    name: "news-subcategory-article",
    path: "/news/:subcategory()/:article()",
    component: () => import("/app/layers/news/app/pages/news/[subcategory]/[article].vue")
  },
  {
    name: "pro-discover-category",
    path: "/pro/discover/:category()",
    component: () => import("/app/layers/pro/app/pages/pro/discover/[category]/index.vue")
  },
  {
    name: "pro-discover-category-article",
    path: "/pro/discover/:category()/:article()",
    component: () => import("/app/layers/pro/app/pages/pro/discover/[category]/[article].vue")
  },
  {
    name: "campaigns-wealth-manager",
    path: "/campaigns/wealth-manager",
    component: () => import("/app/layers/campaigns/app/pages/campaigns/(information)/wealth-manager.vue")
  },
  {
    name: "discover-category-subcategory",
    path: "/discover/:category()/:subcategory()",
    component: () => import("/app/app/pages/discover/[category]/[subcategory]/index.vue")
  },
  {
    name: "campaigns-nhs-pension-advice",
    path: "/campaigns/nhs-pension-advice",
    component: () => import("/app/layers/campaigns/app/pages/campaigns/(information)/nhs-pension-advice.vue")
  },
  {
    name: "discover-category-subcategory-article",
    path: "/discover/:category()/:subcategory()/:article()",
    component: () => import("/app/app/pages/discover/[category]/[subcategory]/[article].vue")
  },
  {
    name: "campaigns-online-financial-adviser",
    path: "/campaigns/online-financial-adviser",
    component: () => import("/app/layers/campaigns/app/pages/campaigns/(information)/online-financial-adviser.vue")
  },
  {
    name: "campaigns-how-to-get-a-mortgage-free-mortgage-guide",
    path: "/campaigns/how-to-get-a-mortgage-free-mortgage-guide",
    component: () => import("/app/layers/campaigns/app/pages/campaigns/how-to-get-a-mortgage-free-mortgage-guide.vue")
  },
  {
    name: "campaigns-accountants-for-small-business",
    path: "/campaigns/accountants-for-small-business",
    component: () => import("/app/layers/campaigns/app/pages/campaigns/(information)/accountants-for-small-business.vue")
  }
]